export const getToken = () => {
  return sessionStorage.getItem("token") || localStorage.getItem("token");
};

export const getExp = () => {
  return sessionStorage.getItem("exp") || localStorage.getItem("exp");
};

export const isLoggedIn = () => {
  return !!getToken();
};
